module.exports = __webpack_public_path__ + "img/25_1.1c47c5df.png";